import React from "react"

import LoadIcon from "../../assets/waiting.svg"
import "./styles.css"

const UpdateTableModal = (props) => {

    return <>
        <div className="update-table-modal">
            <img src={LoadIcon} alt="loading-table" className="loading-img" />
            <h1 className="loading-text">Загружаем {props.tableName}</h1>
        </div>
    </>
}

export default UpdateTableModal;